export const DEFAULT_STATE = [];

export default function (state = DEFAULT_STATE, action) {
    if (action.type === 'MinistryServingOpportunityActions.ON_EVENT') {
        return action.result;
    }

    return state;
}
